export const SET_NUMBER_OF_PAGES = 'PAGINATION/SET_NUMBER_OF_PAGES';
export const SET_PAGE_SIZE = 'PAGINATION/SET_PAGE_SIZE';
export const SET_ACTIVE_PAGE = 'PAGINATION/SET_ACTIVE_PAGE';
export const CLEAR_PAGINATION = 'PAGINATION/CLEAR_PAGINATION';
